import call from 'utils/Api';

/* Types */
import type {
  PlaceAutocompleteRequestType,
  PlaceAutocompleteResponseType,
  PlaceDetailsRequestType,
  PlaceDetailsResponseType,
} from 'types/GooglePlacesTypes';

export const PlaceAutocompleteService = async (
  request: PlaceAutocompleteRequestType,
): Promise<PlaceAutocompleteResponseType> => {
  const { data } = await call('google_maps/autocomplete', request);
  return data;
};

export const PlaceDetailsService = async (
  request: PlaceDetailsRequestType,
): Promise<PlaceDetailsResponseType> => {
  const { data } = await call('google_maps/place_details', request);
  if (data.result.opening_hours?.periods) {
    for (const p of data.result.opening_hours?.periods) {
      if (p.open.day === undefined) {
        p.open.day = 0;
        if (p.close) {
          p.close.day = 0;
        }
        break;
      }
    }
  }
  return data;
};
